import { createContext } from "react";

import { ProfileResource } from "@medplum/core";

interface ProfileContextOptions {
  profile: ProfileResource | undefined;
  isPatient: boolean;
  fullName: string;
}

export const ProfileContext = createContext<ProfileContextOptions>({} as ProfileContextOptions);
